import React from 'react';
import { ClaimEligibilityValidation } from '../../../api';
import * as S from './eligibility.styles';
import { normalize } from './utils';

export const EligibilityValidationsDetails: React.FunctionComponent<{
    validations: ClaimEligibilityValidation[];
}> = React.memo(({ validations }) => {
    return (
        <S.AccordionList>
            {validations.map((validation, i) => {
                return (
                    <S.AccordionPanel key={i} defaultExpanded={true}>
                        <S.AccordionPanelSummary>
                            <S.Subtitle>
                                <S.Warning>{normalize(validation.rejectReasonType)}</S.Warning>
                            </S.Subtitle>
                        </S.AccordionPanelSummary>
                        <S.AccordionPanelDetails>
                            <S.Text>{normalize(validation.followupActionType)}</S.Text>
                        </S.AccordionPanelDetails>
                    </S.AccordionPanel>
                );
            })}
        </S.AccordionList>
    );
});
